import get from 'lodash.get';

export const getPrivateOffer = transactionEdges => {
    const foundTransaction = (transactionEdges || []).find(
        transaction =>
            transaction &&
            transaction.node &&
            transaction.node.isPrivateOffer &&
            !transaction.node.isCanceled
    ) || { node: null };

    return get(foundTransaction, 'node');
};
